import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDiscordIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M19.6361 5.02292C18.1907 4.35768 16.6648 3.88573 15.0973 3.61914C14.8828 4.0046 14.6888 4.40118 14.5159 4.80722C12.8463 4.5543 11.1484 4.5543 9.47881 4.80722C9.30587 4.40122 9.1118 4.00464 8.8974 3.61914C7.32897 3.88799 5.80205 4.36105 4.35518 5.0264C1.48276 9.29864 0.70409 13.4648 1.09342 17.5717C2.77558 18.8212 4.6584 19.7714 6.66003 20.381C7.11074 19.7717 7.50956 19.1252 7.85226 18.4485C7.20135 18.2041 6.57311 17.9025 5.9748 17.5474C6.13227 17.4326 6.28627 17.3143 6.43508 17.1995C8.17601 18.0225 10.0761 18.4493 12 18.4493C13.9238 18.4493 15.8239 18.0225 17.5648 17.1995C17.7154 17.323 17.8694 17.4413 18.0251 17.5474C17.4257 17.9031 16.7963 18.2052 16.1442 18.4502C16.4865 19.1266 16.8853 19.7725 17.3364 20.381C19.3398 19.7738 21.224 18.8241 22.9065 17.5735C23.3633 12.8107 22.1261 8.68285 19.6361 5.02292ZM8.34541 15.046C7.26047 15.046 6.36414 14.0562 6.36414 12.8385C6.36414 11.6209 7.22932 10.6224 8.34195 10.6224C9.45458 10.6224 10.344 11.6209 10.325 12.8385C10.3059 14.0562 9.45112 15.046 8.34541 15.046ZM15.6545 15.046C14.5678 15.046 13.675 14.0562 13.675 12.8385C13.675 11.6209 14.5401 10.6224 15.6545 10.6224C16.7689 10.6224 17.6514 11.6209 17.6323 12.8385C17.6133 14.0562 16.7602 15.046 15.6545 15.046Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDiscordIcon);
export default ForwardRef;
